package dev.danko.roblox_craft_ai.shared.model

import kotlinx.serialization.Serializable

@Serializable
enum class GenerationStatus {
    PENDING,
    PROCESSING,
    READY,
    FAILED
}
